import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CopyIcon } from "@bookingcom/bui-assets-react/streamline";
import { Icon, Link, Text, useToast } from "@bookingcom/bui-react";
import Frame from "../Frame/index.js";
import styles from "./CheckinInfoCardItem.module.css";
export const CheckinInfoCardItem = ({ text, arialLabel, onCopySuccessText }) => {
    const { show: showToast } = useToast();
    return (React.createElement(Frame, { direction: "row", alignItems: "center" },
        React.createElement(Text, { variant: "strong_2", className: styles.text }, text),
        React.createElement(CopyToClipboard, { text: text },
            React.createElement(Link, { attributes: { "aria-label": arialLabel }, text: "", className: styles.clipboardButton, onClick: () => showToast({ text: onCopySuccessText }) },
                React.createElement(Icon, { svg: CopyIcon, size: "small", color: "action" })))));
};
